document.addEventListener('DOMContentLoaded', () => {
  if (!window.Shopify?.designMode && window.location.pathname.replace(/\/$/, '') === '/collections/all/kit-otr') {
    window.location.replace('/search?q=OTR&type=product');
    return;
  }
  const nav = document.querySelector('.wbg-nav');
  if (!nav) return;
  const toggle = nav.querySelector('.wbg-nav__toggle');
  const closeMobile = () => {
    nav.removeAttribute('data-mobile-open');
    toggle?.setAttribute('aria-expanded', 'false');
    toggle?.setAttribute('aria-label', 'Open shop menu');
  };
  toggle?.addEventListener('click', () => {
    const open = nav.getAttribute('data-mobile-open') === 'true';
    if (open) closeMobile();
    else {
      nav.setAttribute('data-mobile-open', 'true');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close shop menu');
    }
  });
  const menus = [...nav.querySelectorAll('.wbg-nav__menu')];
  menus.forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;
      menus.forEach((other) => { if (other !== menu) other.removeAttribute('open'); });
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { menu.removeAttribute('open'); closeMobile(); }));
  });
  nav.querySelectorAll('.wbg-nav__inner > a').forEach((link) => link.addEventListener('click', closeMobile));
  document.addEventListener('click', (event) => {
    if (nav.contains(event.target)) return;
    menus.forEach((menu) => menu.removeAttribute('open'));
    closeMobile();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    menus.forEach((menu) => menu.removeAttribute('open'));
    closeMobile();
  });
  window.addEventListener('resize', () => { if (window.innerWidth > 749) closeMobile(); });
});
